import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import React from 'react';
import { getUserIntent, getPropertyType } from '../../../selectors/selectors';
import { translatePropertyType, userIntentName } from '../../../utils/userIntentConfig';
import actionCreators from '../actions';
import styles from './NewMapNavigationMenuMobile.less';
import useHasMounted from "../../../hooks/useHasMounted";

const NewMapNavigationMenuMobile = ({ userIntent, propertyType, onClickDropdownIcon }) => {
  const hasMounted = useHasMounted();

  return (
    <div className={`grid-item one-whole border-bottom border-top ${styles.nav_bar_sub_menu}`}>
      <div className="grid grid-flex grid-fill-rows vertical-center-container">
        { hasMounted &&
        <span className="grid-item vertical-center-container align-left padding-left-l" id="label-zeige-mir-an">Zeige mir an:</span>
        }
        <div className="grid-item vertical-center-container align-right padding-right-xl">
          <span
            id="wrapper-user-intent"
            onClick={onClickDropdownIcon}
            role="button"
            onKeyDown={(event)=> {
              if (event.key === 'Enter'){
                onClickDropdownIcon()
              }
            }}
            tabIndex={0}>
            <div id="label-user-intent" className="vertical-center margin-right-s" style={{ fontSize: '14px', fontWeight: 'bold' }}>
              {`${userIntent} (${propertyType})`}
            </div>
            <i className="is24-icon-chevron-down vertical-center" />
          </span>
        </div>
      </div>
    </div>
  )};

NewMapNavigationMenuMobile.propTypes = {
  userIntent: PropTypes.string.isRequired,
  propertyType: PropTypes.string.isRequired,
  onClickDropdownIcon: PropTypes.func.isRequired,
};


const mapStateToProps = (state) => ({
  userIntent: userIntentName(getUserIntent(state)),
  propertyType: translatePropertyType(getPropertyType(state)),
});

const mapDispatchToProps = (dispatch) => ({
  onClickDropdownIcon: () => dispatch(actionCreators.openMobileNavigationMenu()),
});

export default connect(mapStateToProps, mapDispatchToProps)(NewMapNavigationMenuMobile);
